/* istanbul ignore file */
import { useEffect, useState } from 'react';
import { getCookie } from '../../utils';
export const useIsLoggedIn = () => {
    const [isLoggedIn, setIsLoggedIn] = useState();
    useEffect(() => {
        setIsLoggedIn(getCookie('token') ? true : false);
    }, []);
    return isLoggedIn;
};
//# sourceMappingURL=use-is-logged-in.js.map